import { useEffect, useState, useCallback } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Copy, Trash2 } from "lucide-react";

export default function AlertsPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/notify-signups");
      setItems(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    if (!window.confirm("Supprimer ce contact ?")) return;
    await api.delete(`/admin/notify-signups/${id}`);
    toast.success("Contact supprimé");
    load();
  };

  const copyEmails = () => {
    const emails = items.filter((i) => i.email).map((i) => i.email).join(", ");
    navigator.clipboard.writeText(emails);
    toast.success("Emails copiés dans le presse-papier");
  };

  const copyPhones = () => {
    const phones = items.filter((i) => i.phone).map((i) => i.phone).join(", ");
    navigator.clipboard.writeText(phones);
    toast.success("Numéros copiés dans le presse-papier");
  };

  if (loading) return <p className="text-white/50">Chargement…</p>;

  return (
    <div className="uf-card overflow-x-auto" data-testid="admin-alerts-panel">
      <div className="p-4 flex items-center gap-2 flex-wrap border-b border-white/10 bg-black/40">
        <span className="text-xs tracking-widest uppercase text-white/50 mr-2">
          {items.length} contact{items.length > 1 ? "s" : ""} à prévenir pour la nouvelle date
        </span>
        <button
          onClick={copyEmails}
          className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest border border-[#FF6B1A]/60 text-[#FF6B1A] px-3 py-1 hover:bg-[#FF6B1A] hover:text-black rounded-full transition-colors"
          data-testid="copy-emails-btn"
        >
          <Copy className="w-3.5 h-3.5" /> Copier les emails ({items.filter((i) => i.email).length})
        </button>
        <button
          onClick={copyPhones}
          className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest border border-[#25D366]/60 text-[#25D366] px-3 py-1 hover:bg-[#25D366] hover:text-black rounded-full transition-colors"
          data-testid="copy-phones-btn"
        >
          <Copy className="w-3.5 h-3.5" /> Copier les téléphones ({items.filter((i) => i.phone).length})
        </button>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-black border-b border-white/20 text-xs tracking-widest uppercase text-white/50">
          <tr>
            <th className="text-left p-3">Prénom</th>
            <th className="text-left p-3">Email</th>
            <th className="text-left p-3">Téléphone</th>
            <th className="text-left p-3">Date</th>
            <th className="text-right p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr><td colSpan={5} className="text-center p-10 text-white/40">Aucun contact pour le moment.</td></tr>
          ) : items.map((i) => (
            <tr key={i.id} className="border-b border-white/5" data-testid={`alert-row-${i.id}`}>
              <td className="p-3">{i.name || "—"}</td>
              <td className="p-3">{i.email || "—"}</td>
              <td className="p-3">{i.phone || "—"}</td>
              <td className="p-3 text-white/50 text-xs">{new Date(i.created_at).toLocaleString("fr-FR")}</td>
              <td className="p-3 text-right">
                <button
                  onClick={() => remove(i.id)}
                  className="text-[#FF3B30] hover:underline"
                  data-testid={`delete-alert-${i.id}`}
                >
                  <Trash2 className="w-4 h-4 inline" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
